/**
 * タスクリストを指定されたフィルター条件でフィルタリングする
 * @param {Array} taskList - フィルタリング対象のタスクリスト
 * @param {Object} selectedFilter - 選択されたフィルター条件
 * @returns {Array} フィルタリング後のタスクリスト
 */
export const filterTasks = (taskList, selectedFilter) => {
  if (!selectedFilter || selectedFilter.id === 'all') {
    return taskList;
  }

  return taskList.filter((task) => {
    const items = Object.values(task.items || {});
    
    switch (selectedFilter.id) {
      case 'dueAndNotConfirmed':
        return items.some((item) => item.dueDate && !item.teacherCheck);
      
      case 'noTestDate':
        return items.some((item) => !item.testDate);
      
      case 'failedConfirmation':
        return items.some((item) => item.passStatus === 'fail');
      
      default:
        return true;
    }
  });
}; 